// eslint-disable-next-line import/prefer-default-export
export const getInvitation = (id: string) =>
  fetch(`/verify/invitations/${id}`, {
    method: 'GET',
    credentials: 'same-origin',
  }).then((response) => response.json());
